module.exports = __webpack_public_path__ + "img/sentiment_dissatisfied.d63ce78f.svg";